import clsx from "clsx";

type SpaceSizeVariant = "default" | "large";

type EmissionsFactorTimelineSpacerProps = {
    size?: SpaceSizeVariant;
};

const EmissionsFactorTimelineSpacer = ({
    size = "default",
}: EmissionsFactorTimelineSpacerProps) => {
    return (
        <div
            className={clsx(
                "flex gap-12",
                size === "default" && "h-[0.625rem]",
                size === "large" && "h-10"
            )}
        >
            <div className="flex flex-col items-center ml-4">
                <div className="w-8" />
                <div className="hidden sm:block flex-1 w-px bg-surface-dark" />
            </div>
        </div>
    );
};

export default EmissionsFactorTimelineSpacer;
